export { default as Divider } from './Divider';
export type { DividerProps } from './types';
